import axios from 'axios';

export default async function favouritesSection() {

  // Favourites class
  const Favourites = class {
    constructor() {
      this.client = axios.create({
        headers: {
          'X-CSRF-Token': window.csrfToken,
          'Content-type': 'application/json'
        }
      });
      this.storageKey = 'aE-f911n-wil-favourites';
    }
    get data() {
      return this.json ? JSON.parse(this.json) : [];
    }
    get json() {
      let json = window.localStorage.getItem(this.storageKey);
      return json ? json : '[]';
    }
    add(id, callback) {
      let data = [...this.data];
      data.push(id);
      window.localStorage.setItem(this.storageKey, JSON.stringify(data));
      this.sync(callback);
    }
    remove(id, callback) {
      let data = [...this.data].filter(_id => {
        return _id !== id;
      });
      window.localStorage.setItem(this.storageKey, JSON.stringify(data));
      this.sync(callback);
    }
    has(id) {
      return this.data.includes(id);
    }
    async sync(callback) {
      await this.client.post(
        '/sync-favourites-session',
        { 
          CSRF_TOKEN: window.csrfToken,
          favourites: this.json
        }
      );
      if (callback) callback();
    }
  }

  // Main object
  const favourites = new Favourites();

  // Call sync on each load to keep the server session fresh
  favourites.sync(null);

  // Add/remove button states
  let updateButtonState = (button, id) => {
    let hasSpan = button.querySelector('span.has');
    let hasNotSpan = button.querySelector('span.has-not');
    if (favourites.has(id)) {
      hasSpan.classList.remove('+hidden');
      hasNotSpan.classList.add('+hidden');
    } else {
      hasSpan.classList.add('+hidden');
      hasNotSpan.classList.remove('+hidden');
    }
  }
  document.querySelectorAll('.favourite-button').forEach(addRemoveButton => {
    if (addRemoveButton) {

      // Button events
      let id = parseInt(addRemoveButton.dataset.favouriteId);
      addRemoveButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        let callback = null;
        if (addRemoveButton.hasAttribute('data-reload')) {
          callback = () => {
            location.href = '/favourites';
          }
        }
        if (favourites.has(id)) {
          favourites.remove(id, callback); 
        } else {
          favourites.add(id, callback);
        }
        updateButtonState(addRemoveButton, id);
      });

      // Initial state
      updateButtonState(addRemoveButton, id);
    }
  });

  // Share button
  const shareButton = document.getElementById('share-favourites-button');
  const copyButton = document.getElementById('share-favourites-popup-copy-button');
  const closeButton = document.getElementById('share-favourites-popup-close-button');
  const copyLinkSpan = document.getElementById('share-favourites-popup-link');
  const copyLink = event => {
    copyLinkSpan.querySelector('i').style.visibility = 'visible';
    navigator.clipboard.writeText(copyLinkSpan.textContent.trim());
  }
  if (shareButton) shareButton.addEventListener('click', event => {
    const sharePopup = document.getElementById('share-favourites-popup');
    if (sharePopup) sharePopup.classList.add('is-open');
    if (copyButton) copyButton.addEventListener('click', copyLink);
    if (copyLinkSpan) copyLinkSpan.addEventListener('click', copyLink);
    if (closeButton) closeButton.addEventListener('click', event => {
      if (sharePopup) {
        sharePopup.classList.remove('is-open');
        if (copyLinkSpan) copyLinkSpan.querySelector('i').style.visibility = 'hidden';
      }
    });
  });
}


// WEBPACK FOOTER //
// ./source/scripts/sections/favourites.js